<!-- eslint-disable vue/no-template-shadow -->
<template>
  <div>
    <Header />
    <b-modal v-model="isCardModalActive" scroll="clip">
      <div class="modal-card-body has-text-centered">
        <h3 class="modal-title">Verifica que tus datos sean correctos</h3>
        <div class="resume-container">
          <div class="resume-line-container">
            <h1 class="resume-label">Cliente: </h1><p class="resume-data">{{ formData[0].fields[0].value + ' ' + formData[0].fields[1].value }}</p>
          </div>
          <div class="resume-line-container">
            <h1 class="resume-label">RUT: </h1><p class="resume-data">{{ formData[0].fields[2].value }}</p>
          </div>
          <div class="resume-line-container">
            <h1 class="resume-label">Correo: </h1><p class="resume-data">{{ formData[1].fields[6].value }}</p>
          </div>
          <div class="resume-line-container">
            <h1 class="resume-label">Teléfono: </h1><p class="resume-data">{{ formData[1].fields[5].value }}</p>
          </div>
          <div class="resume-line-container">
            <h1 class="resume-label">Región: </h1><p class="resume-data">{{ formData[1].fields[0].value }}</p>
          </div>
          <div class="resume-line-container">
            <h1 class="resume-label">Comuna: </h1><p class="resume-data">{{ formData[1].fields[1].value }}</p>
          </div>
          <div class="resume-line-container">
            <h1 class="resume-label">Dirección: </h1><p class="resume-data">{{ formData[1].fields[2].value + ' ' + formData[1].fields[3].value }}</p>
          </div>
          <div class="resume-line-container">
            <h1 class="resume-label">N° Block/Dpto/Casa: </h1><p class="resume-data">{{ formData[1].fields[4].value }}</p>
          </div>
          <div v-if="isDebtor">
            <h3 class="modal-title">Datos del producto</h3>
            <div v-if="formData[3].fields[0].value" class="resume-line-container">
              <h1 class="resume-label">Productos Portados: </h1><p class="resume-data">Todos</p>
            </div>
            <div v-if="formData[3].fields.length > 1" class="resume-line-container">
              <h1 class="resume-label">Productos Portados: </h1><p class="resume-data">{{ formData[3].fields[1].value }}</p>
            </div>
            <div v-if="formData[3].fields.length > 1">
              <div v-for="(products, i) in formData[3].fields.slice(3)" :key="i" class="resume-line-container">
                <h1 class="resume-label">{{ products.typeOfCredit.value }}: </h1><p class="resume-data">{{ products.value }}</p>
              </div>
            </div>
          </div>
          <div v-if="!isDebtor">
            <h3 class="modal-title">Datos del nuevo proveedor</h3>
            <div class="resume-line-container">
              <h1 class="resume-label">Banco o institución financiera: </h1><p class="resume-data">{{ formData[2].fields[0].value }}</p>
            </div>
            <div class="resume-line-container">
              <h1 class="resume-label">RUT: </h1><p class="resume-data">{{ formData[2].fields[1].value }}</p>
            </div>
          </div>
        </div>
        <section>
          <div class="has-text-centered">
            <h3>¡Último paso! Finaliza tu solicitud!</h3>
            <b-button
              id="button-submit-finantial-portability-request"
              class="is-button-primary"
              size="is-medium"
              rounded
              @click="onSubmit">
              Enviar
            </b-button>
            <p v-if="(!valid || isFinancialPortability === null) && submitMessage" class="help is-danger">
              No fue posible validar todos los campos, por favor revisa la información ingresada
            </p>
          </div>
        </section>
      </div>
    </b-modal>
    <b-modal
      v-model="isModalActive"
      :can-cancel="false"
      :close-on-backdrop="false">
      <div class="modal-card-body has-text-centered">
        <h3 class="modal-title">Tu solicitud de portabilidad fue recibida</h3>
        <section class="modal-card-body">
          <strong><p>Mantente atento a tu correo.</p>
            <p>Te informaremos por ese medio los avances de tu solicitud</p></strong>
          <br>
          <img src="@/ui/assets/img/portability-modal.png">
        </section>
        <a
          id="button-finish"
          href="https://www.creditu.com"
          class="button is-big is-button-primary">
          Finalizar
        </a>
      </div>
    </b-modal>
    <div class="portability-content transition-slow">
      <div class="card-item portability-view">
        <div class="portability-form">
          <h3 class="has-text-centered">
            Solicitud de {{ isDebtor ? "Certificado de Liquidación" : "Portabilidad Financiera" }}
          </h3>
          <section v-if="isDebtor" class="message-cliente-portability has-text-centered">
            <div class="message-body-client py-4 mx-2 px-2">
              <p class="legal-advisor-docs my-3">
                ¿Quieres tu certificado para iniciar un procedimiento de Portabilidad Financiera?
              </p>
              <div class="buttons is-centered">
                <b-button
                  id="yesPortabilityButton"
                  class="is-button-secondary px-5"
                  size="is-medium"
                  :active="isFinancialPortability === true"
                  :class="{ active: isFinancialPortability === true }"
                  rounded
                  @click="setStatusPortability(true)">
                  Sí
                </b-button>
                <b-button
                  id="noPortabilityButton"
                  class="is-button-secondary px-5"
                  size="is-medium"
                  :active="isFinancialPortability === false"
                  :class="{ active: isFinancialPortability === false }"
                  rounded
                  @click="setStatusPortability(false)">
                  No
                </b-button>
              </div>
            </div>
          </section>
          <section v-if="!isDebtor" class="message">
            <div class="message-body">
              <p class="legal-advisor">
                Atendiendo la Ley Nº21.236 que regula la Portabilidad Financiera y su reglamento, se
                pone a disposición de las instituciones financieras este canal para gestionar sus
                solicitudes.
              </p>
              <p class="legal-advisor">
                Si eres cliente y necesitas el Certificado de Liquidación,
                <a href="/financial-portability?sender=debtor">haz click aquí.</a>
              </p>
            </div>
          </section>
          <ValidationObserver v-slot="{ valid, errors }" ref="form">
            <form @submit.prevent="onSubmit">
              <section
                v-for="(section, i) in formData"
                :key="i"
                class="transition-slow"
                :class="{ 'hide-section': !section.isVisible }">
                <h4>{{ section.title }}</h4>
                <transition-group name="fields-transition" tag="div" class="columns is-multiline">
                  <div
                    v-for="(field, j) in section.fields"
                    :key="`field-${j}`"
                    class="column"
                    :class="{
                      'is-full-mobile is-full-tablet is-half-desktopis-one-third-widescreen is-two-quarter-fullhd':
                        field.type === 'clearfix',
                      'is-half-tablet is-half-desktop is-one-third-widescreen is-one-quarter-fullhd':
                        field.type !== 'clearfix' && field.type !== 'file',
                    }">
                    <ValidationProvider
                      v-if="field.type !== 'clearfix'"
                      v-slot="{ valid, errors }"
                      :name="field.id"
                      :rules="field.rules"
                      slim>
                      <div class="field">
                        <label
                          v-if="field.label"
                          :class="{
                            'is-focused':
                              currentFocusField === field.id ||
                              formData[i].fields[j].value ||
                              !field.hasAnimatedLabel,
                          }"
                          class="label"
                          :for="field.id">
                          {{ field.label }}
                        </label>
                        <div class="control">
                          <input
                            v-if="field.type === 'text'"
                            :id="field.id"
                            v-model.trim="formData[i].fields[j].value"
                            :oninput="field.oninput"
                            :name="field.id"
                            class="input is-rounded"
                            :class="{ '': errors[0], '': valid }"
                            :type="field.type"
                            :placeholder="currentFocusField !== field.id ? field.label : ''"
                            @focus="currentFocusField = field.id">
                          <span v-if="field.type === 'static'" class="">
                            {{ formData[i].fields[j].value }}
                          </span>
                          <input
                            v-if="field.type === 'products'"
                            :id="field.id"
                            v-model.number="formData[i].fields[j].value"
                            :name="field.id"
                            class="input is-rounded"
                            :class="{ '': errors[0], '': valid }"
                            type="number"
                            :placeholder="currentFocusField !== field.id ? field.label : ''"
                            @focus="currentFocusField = field.id"
                            @input="field.onChange($event.target.value, i)">
                          <b-select
                            v-if="field.type === 'select'"
                            :id="field.id"
                            v-model="formData[i].fields[j].value"
                            :name="field.id"
                            rounded
                            size="is-small"
                            :class="{ '': errors[0], '': valid }"
                            :type="field.type"
                            @focus="currentFocusField = field.id"
                            @input="[field.onChange($event, i, j)]">
                            <option value="">{{ field.label }}</option>
                            <option v-for="item in field.options" :key="item" :value="item">
                              {{ item }}
                            </option>
                          </b-select>

                          <div v-if="field.type === 'radio'">
                            <button
                              v-for="option in field.options"
                              :id="`${field.id}-${option.value}`"
                              :key="option.value"
                              type="button"
                              class="button is-rounded is-button-secondary is-radio-button"
                              :class="{ active: formData[i].fields[j].value === option.value }"
                              :value="option"
                              @click="field.onClick(option.value, i, j)">
                              {{ option.text }}
                            </button>
                            <input
                              :id="field.id"
                              v-model="formData[i].fields[j].value"
                              type="hidden"
                              :name="field.id">
                          </div>

                          <input
                            v-if="field.type === 'requestedProduct'"
                            :id="field.id"
                            v-model="formData[i].fields[j].value"
                            class="input is-rounded transition-slow"
                            :placeholder="field.placeholder"
                            :name="field.index"
                            type="text"
                            @focus="currentFocusField = field.id">

                          <b-select
                            v-if="field.type==='requestedProduct'"
                            :id="`select-${field.id}`"
                            v-model="formData[i].fields[j].typeOfCredit.value"
                            placeholder="Seleccione un producto"
                            class="select-product"
                            :name="field.id"
                            rounded
                            size="is-small"
                            @focus="currentFocusField = field.id">
                            <option v-for="item in field.typeOfCredit.options" :id="item" :key="item" :value="item">{{ item }}</option>
                          </b-select>

                          <div v-if="field.type==='file'">
                            <b-upload
                              v-model="formData[i].fields[j].value"
                              class="file-label">
                              <span class="button is-button-secondary is-rounded">
                                <b-icon class="file-icon" icon="upload" />
                                <span class="file-label">Carga Aquí</span>
                              </span>
                              <div v-if="formData[i].fields[j].value" class="file-name">
                                {{ formData[i].fields[j].value.name }}
                              </div>
                            </b-upload>
                          </div>
                        </div>
                        <p v-if="errors.length" class="help is-danger">{{ field.error }}</p>
                      </div>
                    </ValidationProvider>
                  </div>
                </transition-group>
              </section>
              <section>
                <div class="has-text-centered">
                  <b-button
                    id="button-create-finantial-portability-request"
                    class="is-button-primary"
                    size="is-medium"
                    rounded
                    :disabled="!valid ? !buttonIsEnabled : buttonIsEnabled"
                    :class="{ '': errors[0], '': valid }"
                    @click="onConfirm">
                    Confirmar
                  </b-button>
                  <p v-if="(!valid || isFinancialPortability === null) && submitMessage" class="help is-danger">
                    Por favor revisa que todos los campos estén completos.
                  </p>
                </div>
              </section>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from '@/ui/components/Header.vue';
import {
  createFinancialPortabilityRequestFromFinancialInstitution,
  createFinancialPortabilityRequestFromDebtor,
  createFinancialPortabilityRequestFromDebtorPortability,
  addRequestDocumentToFinancialPortabilityRequest
} from '@/application/services/api-clients/financial-portability';
import { getRegions } from '@/application/services/api-clients/regions';

export default {
  name: 'FinancialPortabilityForm',
  components: { Header },
  data() {
    const formData = [
      {
        title: 'Datos del titular',
        isVisible: true,
        fields: [
          {
            type: 'text',
            id: 'names',
            label: 'Nombres',
            rules: 'required|alpha_spaces',
            value: '',
            error: 'Indica los nombres del titular',
            hasAnimatedLabel: true
          },
          {
            type: 'text',
            id: 'lastNames',
            label: 'Apellidos',
            rules: 'required|alpha_spaces',
            value: '',
            error: 'Indica los apellidos del titular',
            hasAnimatedLabel: true
          },
          {
            type: 'text',
            id: 'idNumber',
            oninput: 'this.value = this.value.toUpperCase()',
            label: 'RUT',
            rules: 'required|idNumberCl',
            value: '',
            error: 'RUT incorrecto (12345678-K)',
            hasAnimatedLabel: true
          }
        ]
      },
      {
        title: 'Datos de contacto y domicilio',
        isVisible: true,
        fields: [
          {
            type: 'select',
            id: 'region',
            label: 'Región',
            rules: 'required',
            onChange: this.updateCommunes,
            value: '',
            error: 'Indica la región del titular',
            options: [],
            hasAnimatedLabel: true
          },
          {
            type: 'select',
            id: 'commune',
            label: 'Comuna',
            rules: 'required',
            onChange: () => {},
            value: '',
            error: 'Indica la comuna del titular',
            options: [],
            hasAnimatedLabel: true
          },
          {
            type: 'text',
            id: 'addresStreet',
            label: 'Calle',
            rules: 'required',
            value: '',
            error: 'Indica la calle del titular',
            hasAnimatedLabel: true
          },
          {
            type: 'text',
            id: 'addresNumber',
            label: 'Numeración',
            rules: 'alpha_dash',
            value: '',
            error: 'Indica la numeración del titular, ej: 1330',
            hasAnimatedLabel: true
          },
          {
            type: 'text',
            id: 'addresBlock',
            label: 'N° Block/Dpto/Casa',
            rules: 'alpha_dash',
            value: '',
            error: 'Indica un valor alfanumérico',
            hasAnimatedLabel: true
          },
          {
            type: 'text',
            id: 'phone',
            label: 'Teléfono',
            rules: 'required|numeric|len:9',
            value: '',
            error: 'Indica el teléfono (9 dígitos)',
            hasAnimatedLabel: true
          },
          {
            type: 'text',
            id: 'email',
            label: 'Correo electrónico',
            rules: 'required|email',
            placeholder: 'correo@creditu.com',
            value: '',
            error: 'Correo inválido',
            hasAnimatedLabel: true
          }
        ]
      },
      {
        title: 'Datos del proveedor inicial',
        isVisible: true,
        fields: [
          {
            type: 'static',
            id: 'originalPovider',
            rules: '',
            label: 'Razón Social',
            value: 'Creditú Administradora de Mutuos Hipotecarios SA',
            hasAnimatedLabel: false
          },
          {
            type: 'static',
            id: 'originalPoviderIdNumber',
            rules: '',
            label: 'RUT',
            value: '76594721-9',
            hasAnimatedLabel: false
          }
        ]
      },
      {
        title: 'Datos de los productos',
        isVisible: true,
        fields: [
          {
            type: 'radio',
            id: 'allProducts',
            rules: 'required',
            label: '¿Deseas incluir todos los productos en la solicitud?',
            options: [
              { text: 'Sí', value: true },
              { text: 'No', value: false }
            ],
            value: true,
            onClick: this.updateAllProductsFlag
          }
        ]
      }
    ];

    return {
      isFinancialPortability: null,
      isDebtor: this.$route.query.sender === 'debtor',
      submitMessage: false,
      isModalActive: false,
      isCardModalActive: false,
      buttonIsEnabled: true,
      regionsMap: {},
      currentFocusField: undefined,
      formData,
      numberOfSectionsAtBeginning: formData.length,
      valid: ''
    };
  },
  async mounted() {
    this.regionsMap = await getRegions('cl');
    this.formData[1].fields[0].options = Object.keys(this.regionsMap);
    if (!this.isDebtor) {
      this.formData.splice(2, 0, {
        title: 'Datos del nuevo proveedor',
        isVisible: true,
        fields: [
          {
            type: 'text',
            id: 'bankName',
            label: 'Banco o institución financiera',
            rules: 'required|alpha_spaces',
            value: '',
            error: 'Indica el nombre de la institución',
            hasAnimatedLabel: true
          },
          {
            type: 'text',
            id: 'bankIdNumber',
            label: 'RUT',
            rules: 'required|idNumberCl',
            value: '',
            error: 'RUT incorrecto (12345678-K)',
            hasAnimatedLabel: true
          },
          {
            type: 'text',
            id: 'contactPerson',
            label: 'Persona de contacto',
            rules: 'required|alpha_spaces',
            value: '',
            error: 'Indica nombres y apellidos',
            hasAnimatedLabel: true
          },
          {
            type: 'text',
            id: 'contactEmail',
            label: 'Correo electrónico',
            rules: 'required|email',
            value: '',
            error: 'Correo inválido',
            hasAnimatedLabel: true
          },
          {
            type: 'text',
            id: 'contactPhone',
            label: 'Teléfono',
            rules: 'required|numeric|len:9',
            value: '',
            error: 'Indica el teléfono (9 dígitos)',
            hasAnimatedLabel: true
          }
        ]
      });
      this.formData.push({
        title: 'Documentación',
        isVisible: true,
        fields: [
          {
            type: 'file',
            id: 'clientRequest',
            label: 'Solicitud de portabilidad firmada por cliente o representante legal',
            rules: 'required|ext:pdf|size:5120',
            error:
              'Debes adjuntar la solicitud de portabilidad en PDF y su tamaño debe ser inferior a 5 mb',
            value: null,
            hasAnimatedLabel: false
          }
        ]
      });
      this.numberOfSectionsAtBeginning = this.formData.length;
    }
  },
  methods: {
    setStatusPortability(value) {
      this.isFinancialPortability = this.isFinancialPortability === value ? null : value;
      this.group = null;
    },
    updateAllProductsFlag(includeAllProducts, sectionIndex, fieldIndex) {
      if (this.formData[sectionIndex].fields[fieldIndex].value === includeAllProducts) return;

      this.formData[sectionIndex].fields[fieldIndex].value = includeAllProducts;

      if (!includeAllProducts) {
        this.formData[sectionIndex].fields.push(
          {
            type: 'products',
            id: 'productQuantity',
            label: '¿Cuántos productos portará?',
            rules: 'min_value:1|max_value:15|required',
            value: '0',
            error: 'Indica al menos 1 producto y no más de 15',
            onChange: this.updateRequestedProducts,
            hasAnimatedLabel: true
          }
        );
      } else {
        this.formData[sectionIndex].fields = this.formData[sectionIndex].fields.slice(0, 1);
      }
      this.updateRequestedProducts(0, sectionIndex);
    },
    formatIdNumber(rut) {
      if (rut.includes('-')) {
        const rutParts = rut.split('-');
        return `${rutParts[0]}-${rutParts[1]}`;
      }
      return `${rut.substring(0, rut.length - 1)}-${rut.substring(rut.length - 1, rut.length)}`;
    },
    processInputData() {
      const inputDataDictionary = {};
      this.formData.forEach(section => {
        section.fields.forEach(field => {
          if (field.id) inputDataDictionary[field.id] = field.value;
        });
      });
      const productSectionIndex = this.isDebtor ? 3 : 4;
      const file = inputDataDictionary.clientRequest;

      const debtor = {
        name: inputDataDictionary.names,
        lastName: inputDataDictionary.lastNames,
        idNumber: this.formatIdNumber(inputDataDictionary.idNumber),
        contact: {
          region: inputDataDictionary.region,
          commune: inputDataDictionary.commune,
          streetName: inputDataDictionary.addresStreet,
          streetNumber: inputDataDictionary.addresNumber,
          phone: inputDataDictionary.phone,
          email: inputDataDictionary.email
        }
      };
      if (inputDataDictionary.addresBlock) {
        debtor.contact.block = inputDataDictionary.addresBlock;
      }

      const companyOperationsIds = this.formData[productSectionIndex].fields
        .filter(p => p.type === 'requestedProduct')
        .map(op => {
          return {
            idProduct: op.value,
            typeProduct: op.typeOfCredit.value
          };
        });
      const includeAllProducts = inputDataDictionary.allProducts;
      const result = { debtor, file, includeAllProducts };
      if (!includeAllProducts) {
        result.companyOperationsIds = companyOperationsIds;
      }
      if (!this.isDebtor) {
        result.financialInstitution = {
          businessName: inputDataDictionary.bankName,
          idNumber: this.formatIdNumber(inputDataDictionary.bankIdNumber),
          contact: {
            name: inputDataDictionary.contactPerson,
            email: inputDataDictionary.contactEmail,
            phone: inputDataDictionary.contactPhone
          }
        };
      }
      return result;
    },
    async onSubmit() {
      if (
        !(await this.$refs.form.validate())
        || (this.isDebtor && this.isFinancialPortability === null)
      ) {
        this.submitMessage = true;
        return;
      }
      this.buttonIsEnabled = false;
      const { debtor, financialInstitution, companyOperationsIds, file, includeAllProducts } = this.processInputData();
      try {
        if (!this.isDebtor) {
          const { _id } = await createFinancialPortabilityRequestFromFinancialInstitution(
            debtor,
            financialInstitution,
            includeAllProducts,
            companyOperationsIds
          );
          await addRequestDocumentToFinancialPortabilityRequest(_id, file);
        }
        if (this.isDebtor && this.isFinancialPortability === true) {
          await createFinancialPortabilityRequestFromDebtorPortability(
            debtor,
            includeAllProducts,
            companyOperationsIds
          );
        }
        if (this.isDebtor && this.isFinancialPortability === false) {
          await createFinancialPortabilityRequestFromDebtor(
            debtor,
            includeAllProducts,
            companyOperationsIds
          );
        }
        this.isModalActive = true;
        this.isCardModalActive = false;
      } catch (_error) {
        this.errorAlert('Hubo un error al crear tu solicitud');
      }
      this.buttonIsEnabled = true;
    },
    async onConfirm() {
      if (
        !(await this.$refs.form.validate())
        || (this.isDebtor && this.isFinancialPortability === null)
      ) {
        this.submitMessage = true;
        this.buttonIsEnabled = false;
      } else if (
        (await this.$refs.form.validate())
        || (this.isDebtor && this.isFinancialPortability === null)
      ) {
        this.submitMessage = false;
        this.isCardModalActive = true;
      }
    },
    updateRequestedProducts(val, sectionIndex) {
      let numberOfProducts = Number(val);
      if (numberOfProducts > 15) numberOfProducts = 15;

      const previousNumberOfProducts = this.formData[sectionIndex].fields.filter(
        f => f.type === 'requestedProduct'
      ).length;

      if (numberOfProducts <= 0) {
        const indexOfFirstField = 3;
        this.formData[sectionIndex].fields.splice(indexOfFirstField, previousNumberOfProducts + 1);
        return;
      }

      const template = productIndex => ({
        type: 'requestedProduct',
        label: `Producto ${productIndex}`,
        placeholder: 'Especifica el producto',
        hasAnimatedLabel: false,
        id: `product-${productIndex}`,
        rules: 'required',
        error: 'Indica el identificador del producto o descártalo',
        typeOfCredit: {
          type: 'typeOfCredit',
          options: ['Crédito Hipotecario', 'Crédito Consumo', 'Crédito Empresas']
        }
      });

      if (previousNumberOfProducts === 0) {
        const newProducts = Array(numberOfProducts)
          .fill(null)
          .map((e, index) => template(index + 1));
        newProducts.unshift({ type: 'clearfix' });
        newProducts.forEach(el => this.formData[sectionIndex].fields.push(el));
        return;
      }

      if (numberOfProducts < previousNumberOfProducts) {
        this.formData[sectionIndex].fields.splice(
          numberOfProducts + 3,
          previousNumberOfProducts - numberOfProducts
        );
        return;
      }
      this.formData.splice(sectionIndex + 1 + previousNumberOfProducts);
      const newProducts = Array(numberOfProducts - previousNumberOfProducts)
        .fill(null)
        .map((e, index) => template(index + 1 + previousNumberOfProducts));
      newProducts.forEach(el => this.formData[sectionIndex].fields.push(el));
    },
    updateCommunes(currentRegion, sectionIndex, fieldIndex) {
      // if (currentRegion === '') {
      //   this.formData[sectionIndex].fields[fieldIndex + 1].options = [];
      //   return;
      // }
      this.formData[sectionIndex].fields[fieldIndex + 1].options = this.regionsMap[currentRegion].sort();
    },
    showOrHideCoOwnerSections(val, sectionIndex) {
      this.formData[sectionIndex].fields[0].value = val;
      this.formData[sectionIndex + 1].isVisible = val === 'sí';
      this.formData[sectionIndex + 2].isVisible = val === 'sí';
    },
    errorAlert(text) {
      this.$buefy.dialog.alert({
        title: 'Error',
        message: text,
        type: 'is-danger',
        hasIcon: true,
        icon: 'times-circle',
        iconPack: 'fa',
        ariaRole: 'alertdialog',
        ariaModal: true
      });
    }
  }
};
</script>
<style lang="css" scoped>
.select-product {
  margin-top: .7rem;
}
.button.is-light:active,
.button.is-light.is-active,
.button:active,
.button.is-active {
  background: var(--primary);
  color: white;
  border: 0px;
}
.file-label {
  display: flex;
  justify-content: left;
  align-items: center;
}
.file-name {
  border-width: 0;
  max-width: 100%;
  font-size: 0.75em;
}
.portability-content {
  width: 100%;
  min-height: calc(100vh - 50px);
  background-color: #4d4d4d0a;
  background-image: url(../../assets/img/burbujas-creditu.svg);
  overflow: hidden;
  background-repeat: no-repeat;
  background-position: bottom right;
  background-size: 40% auto;
  margin-top: 50px;
}
.portability-view {
  width: 80%;
  padding: 60px 40px;
  margin: 0 auto;
  margin-top: 50px;
  margin-bottom: 50px;
}
h3 {
  font-size: 25px;
  color: var(--primary);
  font-weight: 300;
  margin: 10px 0px;
  transition-timing-function: ease-in;
  transition: 0.2s;
}
h4 {
  color: var(--color-nickel);
  font-size: 20px;
  transition-timing-function: ease-in;
  transition: 0.2s;
}
.message-body-client {
  background: #f2fbfb;
  border-radius: 20px;
  font-family: var(--secondary-font);
  color: var(--color-nickel);
}

@media (max-width: 1200px) {
  .portability-view {
    width: 80%;
  }
}
@media (max-width: 992px) {
  .portability-view {
    width: 90%;
  }
  h3 {
    font-size: 22px;
  }
  h4 {
    font-size: 18px;
  }
}
@media (max-width: 768px) {
  .portability-view {
    width: 95%;
  }
  h3 {
    font-size: 20px;
  }
  h4 {
    font-size: 16px;
  }
  .resume-line-container {
    margin: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
  .resume-label {
    color: #00CCD1;
    font-size: 1.2rem;
    text-align: center;
    margin: 0 !important;
    width: auto !important;
  }
.resume-data {
    color: #333538;
    font-size: 1.2rem;
    text-align: center;
    width: auto !important;
    margin: 0 !important;
  }
}
@media (max-width: 576px) {
  .portability-view {
    width: 100%;
  }
  h3 {
    font-size: 20px;
  }
  h4 {
    font-size: 16px;
  }
}
@media (max-width: 350px) {
  .choice-docs button {
    width: 80%;
    margin: 5px auto;
  }
}
.label {
  font-size: 12px;
  color: var(--primary);
  margin-bottom: 0;
  transition-timing-function: ease-in;
  transition: 0.2s;
  transform: translateY(50%);
  opacity: 0;
}
label.is-focused {
  transition: 0.2s;
  visibility: visible;
  opacity: 1;
  transition-timing-function: ease-out;
  transition: 0.25s;
  transform: translateY(0);
}
button.active,
button.active:active,
button.active:focus {
  background: var(--primary);
  color: #fff;
}
section.hide-section {
  visibility: hidden;
  position: absolute;
  margin: 0;
  opacity: 0;
  transition: opacity 0.5s linear, transform 0.5s cubic-bezier(0.2, 0.5, 0.1, 1);
}
section {
  margin-top: 35px;
  visibility: visible;
  transform: translateY(-1em);
  opacity: 1;
}
.fields-transition-enter-active {
  transition: opacity 0.5s linear, transform 0.5s cubic-bezier(0.2, 0.5, 0.1, 1);
}
.fields-transition-enter {
  opacity: 0;
}
.fields-transition-leave-to,
.fields-transition-leave-active {
  transition: opacity 0.5s linear, transform 0.5s cubic-bezier(0.2, 0.5, 0.1, 1);
}
.fields-transition-enter {
  transform: translateX(-1em);
}
.fields-transition-leave-to {
  transform: translateX(-1em);
  opacity: 0;
}
.is-radio-button {
  margin-right: 15px;
}
.resume-container {
  background: #ffffff;
  display: flex;
  flex-direction: column;
  margin: 3rem 0;
}
.resume-line-container {
  margin: 1rem auto;
  line-height: 1;
  display: flex;
  width: 80%;
}
.resume-label {
  color: #00CCD1;
  font-size: 1.2rem;
  text-align: left !important;
  margin-left: 9rem;
  width: 40%;
}
.resume-data {
  color: #333538;
  font-size: 1.2rem;
  text-align: left !important;
  width: 60%;
    margin-left: 5rem;
}
</style>
